import { Button, Form, Input, message, Modal, Select } from "antd";
import React, { CSSProperties, useEffect, useState } from "react";
import {
  useProductTypeList,
  useGetProductById,
  useCreateProduct,
  useUpdateProduct,
} from "../../api/product";
import { DeleteOutlined } from "@ant-design/icons";
import { useGetFarmingStageList } from "../../api/farming_stage";

type ProductModalProps = {
  open: boolean;
  selectedId: string;
  hideModal: () => void;
};

interface ITag {
  key: string;
  value: string;
}

const wrapper: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 10,
  marginTop: 25,
};

const label: CSSProperties = {
  fontFamily: "Poppins",
  fontSize: 15,
};
const AdminProductModal: React.FC<ProductModalProps> = ({
  open,
  selectedId,
  hideModal,
}) => {
  const [unit, setUnit] = useState<string | undefined>();
  const [tags, setTags] = useState<ITag[]>([]);
  const [tagKey, setTagKey] = useState<string>();
  const [tagValue, setTagValue] = useState<string>();

  const { data: productTypes } = useProductTypeList();

  const { data: selectedProduct } = useGetProductById(selectedId);

  const [productType, setProductType] = useState<string | undefined>(
    selectedProduct?.data?.category,
  );
  const [name, setName] = useState<string>(
    selectedProduct?.data?.productName || "",
  );
  const [variety, setVariety] = useState<string | null>(
    selectedProduct?.data?.variety || null,
  );
  const [description, setDescription] = useState<string | undefined>();

  // const { data: categoriesData } = useInputCategoryList();
  // const { data: unitsData } = useUnits();
  const { mutateAsync: createProduct, isPending: creating } =
    useCreateProduct();
  const {
    mutateAsync: updateProduct,
    isSuccess,
    isPending: updating,
  } = useUpdateProduct();

  // const { data: input } = useInputById(selectedId);

  // useEffect(() => {
  //     if (categoriesData?.data) {
  //         setProducts(categoriesData.data.map(x => x))
  //     }
  // }, [categoriesData]);

  useEffect(() => {
    if (selectedProduct && selectedProduct.data && selectedProduct.data.data) {
      setProductType(selectedProduct.data.data.category);
      setName(selectedProduct.data.data.productName);
      setVariety(selectedProduct.data.data.variety);
      setUnit(selectedProduct.data.data.unit);
      setDescription(selectedProduct.data.data.description);

      if (selectedProduct.data.data.detail) {
        const val = Object.entries(
          JSON.parse(selectedProduct.data.data.detail),
        ).map((m: any) => {
          return { key: m[0], value: m[1] };
        });

        setTags(val);
      }
    }
  }, [selectedProduct]);

  const onsubmit = async () => {
    const _tags = tags.reduce((acc, tag) => {
      return { ...acc, ...(tag.key ? { [tag.key]: tag.value } : tag) };
    }, {});

    if (productType && name && variety) {
      if (selectedId) {
        try {
          const result = await updateProduct({
            id: selectedId,
            product: {
              category: productType,
              productName: name,
              variety,
              detail: JSON.stringify(_tags),
              description,
              unit,
            },
          });
          if (result && result.status === 200) {
            message.success("Product created successfully");
          }
        } catch (err: any) {
          message.error("Operation failed");
        }
      } else {
        try {
          const result = await createProduct({
            category: productType,
            productName: name,
            variety,
            detail: JSON.stringify(_tags),
            description,
            unit,
          });
          if (result && result.status === 200) {
            message.success("Product created successfully");
          }
        } catch (err: any) {
          message.error("Operation failed");
        }
      }
    }
    hideModal();
  };

  const handleInsertTag = () => {
    if (tagKey && tagValue) {
      const _tag = tags.find((tag) => tag.key === tagKey);

      if (!_tag) {
        setTags((prev) => [...prev, { key: tagKey, value: tagValue }]);
        setTagKey(undefined);
        setTagValue(undefined);
      }
    }
  };

  const handleRemoveTag = (key: string) => {
    if (key) {
      const _tags = tags.filter((tag) => tag.key !== key);
      setTags(_tags);
    }
  };

  const { TextArea } = Input;
  return (
    <Modal
      width={"60%"}
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          {selectedId ? "Edit product" : "Create new "}
        </div>
      }
      open={open}
      centered
      onOk={onsubmit}
      onCancel={hideModal}
      closable
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          color: "black",
          gap: 12,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            width: "49%",
          }}
        >
          {productTypes &&
            productTypes.data &&
            productTypes.data.length > 0 && (
              <Select
                value={productType}
                placeholder="Select product type"
                style={{ width: "100%" }}
                onChange={(val: any) => setProductType(val)}
                options={productTypes?.data.map((type: string) => {
                  return { label: type, value: type };
                })}
              />
            )}
          <Input
            placeholder="Insert name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Input
            placeholder="Insert variety"
            value={variety || ""}
            onChange={(e) => setVariety(e.target.value)}
          />
          <Select
            value={unit}
            placeholder="Select unit"
            style={{ width: "100%" }}
            onChange={(val: any) => setUnit(val)}
            options={["Ltr", "Kg"].map((type: string) => {
              return { label: type, value: type };
            })}
          />
          <TextArea
            rows={4}
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            marginTop: 5,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 4,
            }}
          >
            <svg
              width="30px"
              height="30px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.0498 7.0498H7.0598M10.5118 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V10.5118C3 11.2455 3 11.6124 3.08289 11.9577C3.15638 12.2638 3.27759 12.5564 3.44208 12.8249C3.6276 13.1276 3.88703 13.387 4.40589 13.9059L9.10589 18.6059C10.2939 19.7939 10.888 20.388 11.5729 20.6105C12.1755 20.8063 12.8245 20.8063 13.4271 20.6105C14.112 20.388 14.7061 19.7939 15.8941 18.6059L18.6059 15.8941C19.7939 14.7061 20.388 14.112 20.6105 13.4271C20.8063 12.8245 20.8063 12.1755 20.6105 11.5729C20.388 10.888 19.7939 10.2939 18.6059 9.10589L13.9059 4.40589C13.387 3.88703 13.1276 3.6276 12.8249 3.44208C12.5564 3.27759 12.2638 3.15638 11.9577 3.08289C11.6124 3 11.2455 3 10.5118 3ZM7.5498 7.0498C7.5498 7.32595 7.32595 7.5498 7.0498 7.5498C6.77366 7.5498 6.5498 7.32595 6.5498 7.0498C6.5498 6.77366 6.77366 6.5498 7.0498 6.5498C7.32595 6.5498 7.5498 6.77366 7.5498 7.0498Z"
                stroke="#009602"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div style={{ fontFamily: "Poppins", fontSize: 15 }}>Tags</div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              border: "1px solid #E6EEF6",
              borderRadius: 4,
              gap: 12,
              paddingLeft: 50,
              paddingRight: 50,
              paddingTop: 0,
              paddingBottom: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                marginTop: -10,
              }}
            >
              {tags &&
                tags.map((tag) => (
                  <div
                    key={tag.key}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #DCE2E4",
                      paddingTop: 20,
                      paddingBottom: 5,
                    }}
                  >
                    <div>{Object.values(tag)[0]}</div>
                    <div>
                      {tag.value}{" "}
                      <DeleteOutlined
                        style={{ color: "red" }}
                        onClick={() => handleRemoveTag(tag.key)}
                      />
                    </div>
                  </div>
                ))}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 12,
                width: "100%",
              }}
            >
              <div style={{ ...wrapper, width: "50%", marginTop: 15 }}>
                <div style={label}>Key</div>
                <Input
                  value={tagKey}
                  onChange={(e) => setTagKey(e.target.value)}
                  placeholder="Insert key"
                />
              </div>

              <div style={{ ...wrapper, width: "50%", marginTop: 15 }}>
                <div style={label}>Value</div>
                <Input
                  value={tagValue}
                  onChange={(e) => setTagValue(e.target.value)}
                  placeholder="Insert value"
                />
              </div>
            </div>
            <Button style={{ width: 150 }} onClick={handleInsertTag}>
              Add new tag
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AdminProductModal;
